import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $rotate: number }>`
  transition: transform 0.2s ease-in-out;
  transform: rotate(0deg);
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${(props) => css`
    transform: rotate(${props.$rotate}deg);
  `}
`;
